import * as React from 'react';
import { Room } from '../../../../store/filters/model';
import { Label } from '../../../../ui/label/label';
import { PikDropdown } from '../../../../ui/pik_dropdown/pik_dropdown';
import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../../../types/redux';
import { roomsChange } from '../../../../actions/filter';

interface IRoomsProps {
  rooms: Room[];
  setRooms(rooms: Room[]): void;
}

class Rooms extends React.PureComponent<IRoomsProps, object> {
  private values: Array<{ label: string; value: Room }> = [
    {
      label: 'Студия',
      value: 'studio',
    },
    {
      label: '1',
      value: 'oneRoom',
    },
    {
      label: '2',
      value: 'twoRoom',
    },
    {
      label: '3',
      value: 'threeRoom',
    },
    {
      label: '4+',
      value: 'fourRoom',
    },
  ];

  public render() {
    return (
      <Label text="Комнат:">
        <PikDropdown
          multiple
          placeholder="Не важно"
          value={this.props.rooms}
          onValueChange={this.props.setRooms}
          values={this.values}
          popupContentStyle={{ paddingBottom: 12 }}
        />
      </Label>
    );
  }
}

export const RoomsField = connect(
  (state: IApplicationState) => ({
    rooms: state.filter.query.rooms,
  }),
  (dispatch: TTypedThunkDispatch) => {
    return {
      setRooms: (rooms: Room[]) => {
        dispatch(roomsChange(rooms));
      },
    };
  },
)(Rooms);
